<div class="extensive-reach">
    <div class="mainWrap">
        <div class="headerWrap">
            Our Extensive Reach
        </div>
        <div class="bodyWrap">
            <div class="rowWrap" *ngFor="let i of extensiveReach">
                <div class="card">
                    <img class="image" src="{{i.bgImageUrl}}">
                    <div class="overLay">
                       {{i.title}}
                    </div>
                </div>
            </div>
        </div>

        <div class="buttonWrapForAllIndustries">
            <div class="buttonWrap">
                <button [routerLink]="['/industries']">
                View All Industries
                </button>
            </div>
        </div>
    </div>
</div>